/**
 * Interface for the 'CustomFields' data
 */
export enum CustomFieldType {
    STRING = 'string',
    INTEGER = 'integer',
    FLOAT = 'float',
    BOOLEAN = 'boolean',
    DATE = 'date'
}

export interface CustomFieldsEntity {
    id: string;
    parent_type: string;
    parent_id: string;
    name: string;
    display_name: string;
    type: CustomFieldType;
    value: string | number | boolean | null | Date;
}
